module.exports = __webpack_public_path__ + "static/printer-3-b591404b655f7c38305668c7b16fc946.png";